<template>
  <el-card class="ask-card--com box-card" shadow="hover" ref="askCardRef">
    <template v-if="cardData.isQuestion !== undefined">
      <div v-show-more class="answer-line">
        <div class="text-wrap">
          <div class="title-wrap ask-title">
            <div class="title" @mousedown.left.stop="copyClick($event)"><i class="theme ask-icon">主题</i>：{{cardData.theme}}</div>
          </div>
          <div class="explain" @mousedown.left.stop="copyClick($event)">
            <p>   </p><hr>
            <!-- <i class="answer ask-icon">问</i>：{{cardData.question}}<hr> -->
            <i class="answer ask-icon">问</i><span v-html="cutout(cardData.question)"/><hr>
            <!-- <i class="answer ask-icon">答</i>：{{cardData.answer}} -->
            <i class="answer ask-icon">答</i><span v-html="cutoutA(cardData.answer)"/>
          </div>
          <div class="tip">
            <p @mousedown.left.stop="copyClick($event)">
              信息来源：
              {{cardData.messageSource}}
            </p>
            <p @mousedown.left.stop="copyClick($event)">
              问答来源：
              {{cardData.answerSource}}
            </p>
            <p v-if="cardData.questionTime" @mousedown.left.stop="copyClick($event)">
              提问时间：
              {{cardData.questionTime | transformTime}}
            </p>
            <p v-if="cardData.answerTime" @mousedown.left.stop="copyClick($event)">
              答复时间：
              {{cardData.answerTime | transformTime}}
            </p>
          </div>
          <span class="less-btn">收起</span>
        </div>
        <span class="more-btn" @click="handleMore">展开</span>
      </div>
    </template>
    <template v-else>
      <div v-show-more class="answer-line">
        <div class="text-wrap">
          <div class="title-wrap">
            <div class="title" @mousedown.left.stop="copyClick($event)">{{cardData.termChinese}}</div>
            <!-- <i class="el-icon-star-on" v-if="cardData.collectionType" @click.stop="doDeleteFavorite(cardData)">取消收藏</i>
            <i class="el-icon-star-off" v-else @click.stop="doAddFavorite(cardData)">收藏</i> -->
          </div>
          <div>
            <p class="english-title" @mousedown.left.stop="copyClick($event)">{{cardData.termEnglish}}</p>
          </div>
          <p class="explain" @mousedown.left.stop="copyClick($event)">
            释义：
            <!-- $a^{2}$ -->
            {{cardData.explain}}
          </p>
          <div class="tip">
            <p @mousedown.left.stop="copyClick($event)">
              来源：
              {{cardData.source}}
            </p>
            <p @mousedown.left.stop="copyClick($event)">
              分类：
              {{cardData.classa}}
            </p>
            <p @mousedown.left.stop="copyClick($event)">
              部门：
              {{cardData.department}}
            </p>
            <p @mousedown.left.stop="copyClick($event)">
              实施时间：
              {{cardData.timet | transformTime}}
            </p>
          </div>
        </div>
        <span class="less-btn">收起</span>
        <span class="more-btn" @click="handleMore">展开</span>
      </div>
    </template>
    <span class="copy-box" ref="copyRef" @click="handleCopy()">复制(ctrl + c)</span>
  </el-card>
</template>

<script>
/* eslint-disable no-undef */
import api from '../../../api/index'
// import goodsAddress from '@/components/goods-com/address.vue'
export default {
  props: ['cardData'],
  data () {
    return {
      showAddressList: false,
      goodsDetail: {}
    }
  },
  mounted () {
    MathJax.Hub.Queue(['Typeset', MathJax.Hub, this.$refs.askCardRef.$el])
  },
  methods: {
    cutout (question) {
      return question.replace(/；；/g, '</br>')
    },
    cutoutA (answer) {
      return answer.replace(/；；/g, '</br>')
    },
    // handleAddressClose (item) {
    //   this.loading = this.$loading()
    //   api.addOrder({
    //     convertNumbers: 1,
    //     consigneeId: item.id,
    //     waresId: this.goodsId
    //   }).then(res => {
    //     this.loading && this.loading.close()
    //     if (res.code === 200) {
    //       this.$confirm('我们会尽快安排发货，可以在个人中心，查看已兑换奖品列表哦~', '领取成功', {
    //         type: 'success',
    //         confirmButtonText: '前往查看',
    //         cancelButtonText: '稍后查看'
    //       }).then(() => {
    //         this.$router.push('/personal-center?hash=gift')
    //       }).catch(() => {
    //       })
    //     } else {
    //       this.$message({
    //         type: 'warning',
    //         message: res.message || '兑换失败，请稍后再试'
    //       })
    //     }
    //   })
    // },
    handleMore () {
      api.countDownload({
        fileId: this.cardData.id,
        type: this.isTerm ? 3 : 4
      }).then(res => {
        if (res.code === 500) {
          this.loading && this.loading.close()
          this.$message({
            message: res.message,
            type: 'warning'
          })
        } else if (res.code === 200) {
          if (res.data.uptotal && !res.data.waresId) {
            this.$message({
              offset: 40,
              message: '恭喜！运气真好，获得' + res.data.uptotal + '个环境豆奖励！',
              type: 'success',
              duration: 5000,
              center: true
            })
          } else if (res.data.waresId) {
            this.showAddressList = true
            this.goodsId = res.data.waresId
            api.getGoodsDetail({
              type: 0,
              id: this.goodsId
            }).then(res => {
              console.log(res)
              if (res.code === 200) {
                this.goodsDetail = res.data
              }
            })
          }
        }
      })
    },
    getUrlName (url) {
      const tmpArr = url.split('/')
      const name = tmpArr[tmpArr.length - 1]
      return name
    },
    doDeleteFavorite (item) {
      this.$emit('delete', item)
    },
    doAddFavorite (item) {
      this.$emit('add', item)
    },
    copyClick (e) {
      const downPageX = e.pageX
      e.target.onmouseup = (event) => {
        if (Math.abs(downPageX - event.pageX) < 10) {
        } else {
          this.showCopy(e)
        }
      }
    },
    showCopy (e) {
      this.$refs.copyRef.style.display = 'block'
      this.$refs.copyRef.style.top = e.target.offsetTop + e.target.clientHeight + 'px'
      this.$refs.copyRef.style.left = e.target.offsetLeft + e.target.clientWidth / 3 + 'px'
      this.selStr = window.getSelection().toString()
    },
    handleCopy (str) {
      const aux = document.createElement('input')
      aux.setAttribute('value', str || this.selStr)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$refs.copyRef.style.display = 'none'
    }
  },
  computed: {
    url () {
      return this.cardData.url || this.cardData.presentationUpload
    },
    isAsk () {
      return Boolean(this.cardData.isQuestion === 0)
    },
    isTerm () {
      return Boolean(this.cardData.termId)
    }
  },
  directives: {
    showMore: function (el) {
      setTimeout(() => {
        if (el.querySelector('.text-wrap').clientHeight > 70) {
          el.querySelector('.more-btn').style.display = 'block'
          el.querySelector('.more-btn').onclick = () => {
            el.style.maxHeight = '2000px'
            el.querySelector('.more-btn').style.display = 'none'
            el.querySelector('.less-btn').style.display = 'inline-block'
          }
          el.querySelector('.less-btn').onclick = () => {
            el.style.maxHeight = '64px'
            el.querySelector('.more-btn').style.display = 'block'
          }
        }
      }, 100)
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
.ask-card--com.box-card {
  margin: 8px;
  position: relative;
  overflow: visible;
  &:hover {
    cursor: pointer;
  }
  .el-card__header {
    padding: 8px 12px;
  }
  .el-card__body {
    padding: 8px 12px;
    overflow: hidden;
  }
  .answer-line {
    max-height: 64px;
    overflow: hidden;
    position: relative;
    .title-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      i {
        flex: 0 0 auto;
        margin-left: 12px;
        &:hover {
          cursor: pointer;
          color: #409EFF;
        }
      }
    }
    .ask-title {
      .title {
        margin-bottom: 16px;
        line-height: 20px;
        margin-top: 6px;
        flex: 1;
      }
      i {
        margin-bottom: 16px;
        line-height: 20px;
        margin-top: 6px;;
      }
    }
    .title {
      font-weight: bold;
      flex: 1 1 auto;
      font-size: 16px;
      -webkit-user-select: text;
      display: inline-block;
      padding: 0 2px;
    }
    .english-title {
      color: #83889a;
      -webkit-user-select: text;
      display: inline-block;
      padding: 0 2px;
    }
    .explain {
      -webkit-user-select: text;
      display: inline-block;
      padding: 0 2px;
    }
    .tip {
      color: #83889a;
      font-size: 12px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      p {
        flex: 0 0 46%;
        padding: 0 2px;
        -webkit-user-select: text;
        &.item-active {
          color: #409eff;
        }
      }
    }
    .more-btn {
      position: absolute;
      right: 0;
      bottom: 0;
      background: linear-gradient(to right, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 1));
      display: none;
      padding: 2px 0px 2px 120px;
      cursor: pointer;
      color: #409EFF;
      line-height: 1.3;
    }
    .less-btn {
      background: linear-gradient(to right, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 1));
      display: none;
      float: right;
      cursor: pointer;
      color: #409EFF;
      line-height: 1.3;
    }
    .ask-icon {
      border-radius: 4px;
      height: 20px;
      width: 40px;
      text-align: center;
      line-height: 20px;
      background: #E6A23C;
      margin: 0!important;
      font-style: normal;
      display: inline-block;
      vertical-align: text-bottom;
      color: #fff!important;
      font-size: 14px;
      &.answer {
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 12px;
        background: #67C23A;
        color: #fff!important;
      }
    }
  }
  .copy-box {
    position: absolute;
    font-weight: normal;
    font-size: 12px;
    border: 1px solid #ebecf1;
    padding: 2px 4px;
    background: #F2F6FC;
    display: none;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    &:hover {
      background: #409EFF;
      color: #fff;
    }
  }
  .gift-address {
    position: relative;
    .des {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 8px 0;
      .title {
        flex: 1;
        font-size: 22px;
      }
      img {
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 4px;
        object-fit: cover;
        margin-right: 8px
      }
    }
    .icon {
      position: absolute;
      width: 60px;
      left: 120px;
      top: 40px;
      opacity: 0.7;
      z-index: 0;
      transform: rotate(-15deg);
    }
  }
}
</style>
